import React from 'react'
import { Link } from 'react-router-dom'
import Header from '../../headerone/Main'
import Breadcrumb from '../../Breadcrumb/Main'

const teachers = [

    {
        Name: "B. Ananth Kumar",
        Position: "Ph.D Scholar",
        Batch: "July 2022",
        AreasofResearch: "Total Synthesis of Terpenoids",
        GuideName: "Dr. Venkaiah Chintalapudi",
        GuideLink: "/dr-venkaiah-chintalapudi",
        Email: "cy22d502@iittp.ac.in",
        Image: "https://files.iittp.ac.in/pics/researchscholars/cy/Ananth.jpg"
    },
    {
        Name: "Harsha P G",
        Position: "Ph.D Scholar",
        Batch: "July 2022",
        AreasofResearch: "Supramolecular Chemistry",
        GuideName: "Dr. Sourav Chakraborty",
        GuideLink: "/dr-sourav-chakraborty",
        Email: "cy22d504@iittp.ac.in",
        Image: "https://files.iittp.ac.in/pics/researchscholars/cy/Harsha.jpg"
    },
    {
        Name: "Kamsala Rachana",
        Position: "Ph.D Scholar",
        Batch: "July 2022",
        AreasofResearch: "Bioinorganic Chemistry",
        GuideName: "Prof. Gouriprasanna Roy",
        GuideLink: "/dr-gouriprasanna-roy",
        Email: "cy22d505@iittp.ac.in",
        Image: "https://files.iittp.ac.in/pics/researchscholars/cy/Kamsala.jpg"
    },
    {
        Name: "Pankaj Adhikary",
        Position: "Ph.D Scholar",
        Batch: "July 2022",
        AreasofResearch: "Theoretical Investigation of Small Molecules in Aqueous Phase",
        GuideName: "Dr. Rajib Biswas",
        GuideLink: "/dr-rajib-biswas",
        Email: "cy22d506@iittp.ac.in",
        Image: "https://files.iittp.ac.in/pics/researchscholars/cy/Pankaj.jpg"
    },
    {
        Name: "Prashanta Bauri",
        Position: "Ph.D Scholar",
        Batch: "July 2022",
        AreasofResearch: "Theoretical Chemistry",
        GuideName: "Dr. Debasish Mondal",
        GuideLink: "/dr-debasish-mondal",
        Email: "cy22d507@iittp.ac.in",
        Image: "https://files.iittp.ac.in/pics/researchscholars/cy/Prashanta.jpg"
    },
    {
        Name: "Snehasish Senapati",
        Position: "Ph.D Scholar",
        Batch: "July 2022",
        AreasofResearch: "Total Synthesis of Terpinoids",
        GuideName: "Dr. Venkaiah Chintalapudi",
        GuideLink: "/dr-venkaiah-chintalapudi",
        Email: "cy22d508@iittp.ac.in",
        Image: "https://files.iittp.ac.in/pics/researchscholars/cy/Snehasish.jpg"
    },
    {
        Name: "Kongki Gogoi",
        Position: "Ph.D Scholar",
        Batch: "January 2022",
        AreasofResearch: "Supramolecular Chemistry",
        GuideName: "Dr. Sourav Chakraborty",
        GuideLink: "/dr-sourav-chakraborty",
        Email: "cy22d001@iittp.ac.in",
        Image: "https://files.iittp.ac.in/pics/researchscholars/cy/Kongki%20Gogoi.jpg"
    },
    {
        Name: "Vikash Kumar",
        Position: "Ph.D Scholar",
        Batch: "July 2020",
        AreasofResearch: "Transition Metal catalyzed Organic synthesis, Metallo-Photo redox catalysis, Metallo-Electro Catalysis",
        GuideName: "Dr. P. Gandeepan",
        GuideLink: "/dr-p-gandeepan",
        Email: "cy20d505@iittp.ac.in",
        Image: "https://files.iittp.ac.in/pics/researchscholars/cy/vikash.jpg"
    },
    {
        Name: "Lusina Mantry",
        Position: "Ph.D Scholar",
        Batch: "July 2020",
        AreasofResearch: "Photocatalysis and Transition metal catalyzed reaction",
        GuideName: "Dr. P. Gandeepan",
        GuideLink: "/dr-p-gandeepan",
        Email: "cy20d503@iittp.ac.in",
        Image: "https://files.iittp.ac.in/pics/researchscholars/cy/lusina.jpg"
    },
    {
        Name: "Rafna Rafeek",
        Position: "Ph.D Scholar",
        Batch: "July 2020",
        AreasofResearch: "Theoretical Chemistry",
        GuideName: "Dr. Debasish Mondal",
        GuideLink: "/dr-debasish-mondal",
        Email: "cy20d504@iittp.ac.in",
        Image: "https://files.iittp.ac.in/pics/researchscholars/cy/rafna.jpg"
    },
    {
        Name: "Gedela Susheela",
        Position: "Ph.D Scholar",
        Batch: "Jan 2020",
        AreasofResearch: "Bioinorganic Chemistry",
        GuideName: "Prof. Gouriprasanna Roy",
        GuideLink: "/dr-gouriprasanna-roy",
        Email: "cy20d502@iittp.ac.in",
        Image: "https://files.iittp.ac.in/pics/researchscholars/cy/SUSHEELA.jpg"
    },
    {
        Name: "Amirul Islam",
        Position: "Ph.D Scholar",
        Batch: "Jul 2020",
        AreasofResearch: "Bioinorganic Chemistry",
        GuideName: "Dr. Gouriprasanna Roy",
        GuideLink: "/dr-gouriprasanna-roy",
        Email: "cy20d501@iittp.ac.in",
        Image: "https://files.iittp.ac.in/pics/researchscholars/cy/AMIRUL.jpg"
    },
    {
        Name: "Rudra Shankar Pati",
        Position: "Ph.D Scholar",
        Batch: "Jan 2020",
        AreasofResearch: "Bioinorganic Chemistry, Chemical Biology",
        GuideName: "Prof. Gouriprasanna Roy",
        GuideLink: "/dr-gouriprasanna-roy",
        Email: "cy20d002@iittp.ac.in",
        Image: "https://files.iittp.ac.in/pics/researchscholars/cy/RSP.jpg"
    },
    {
        Name: "Albin Joy",
        Position: "Ph.D Scholar",
        Batch: "July 2019",
        AreasofResearch: "Theoretical Chemistry",
        GuideName: "Dr. Rajib Biswas",
        GuideLink: "/dr-rajib-biswas",
        Email: "cy19d501@iittp.ac.in",
        Image: "https://files.iittp.ac.in/images/demo/iit/researchscholars/albin.jpeg"
    },
    {
        Name: "K.Devendra Reddy",
        Position: "Ph.D Scholar",
        Batch: "July 2018",
        AreasofResearch: "Theoretical chemistry",
        GuideName: "Dr. Rajib Biswas",
        GuideLink: "/dr-rajib-biswas",
        Email: "cy18d501@iittp.ac.in",
        Image: "https://files.iittp.ac.in/images/demo/iit/researchscholars/cy18d501_ devendra.jpg"
    },
    {
        Name: "Raka Ahmed",
        Position: "Ph.D Scholar",
        Batch: "July 2018",
        AreasofResearch: "Theoretical and Computational Chemistry",
        GuideName: "Dr. Arun K Manna",
        GuideLink: "/dr-arun-k-manna",
        Email: "cy18d502@iittp.ac.in",
        Image: "https://files.iittp.ac.in/images/demo/iit/researchscholars/cy18d502_RakaAhmed.jpg"
    },
    {
        Name: "Syed Yunus Ali",
        Position: "Ph.D Scholar",
        Batch: "July 2018",
        AreasofResearch: "Theoritical Chemistry",
        GuideName: "Dr. Debasish Mondal",
        GuideLink: "/dr-debasish-mondal",
        Email: "cy18d503@iittp.ac.in",
        Image: "https://files.iittp.ac.in/images/demo/iit/researchscholars/syed.jpg"
    }


]



function Main() {

    return (
        <>
            <Header />
            <Breadcrumb title="Home" subtitle="Chemistry" />
            <section className="team-area fix p-relative pt-120 pb-80">
                 
                <div className="container">
                    <div className="row">
                        <div className="col-lg-12 p-relative">
                            <div className="section-title center-align mb-50 text-center wow fadeInDown animated" data-animation="fadeInDown" data-delay=".4s">
                                <h5>
                                    <i className="fal fa-graduation-cap" /> Research Scholars
                                </h5>
                                <h2>Chemistry</h2>
                            </div>
                        </div>
                    </div>
                    <div className="row">
                        {teachers.map((teacher, index) => (
       
                           <div key={index} className="col-xl-3 col-md-6 col-sm-6">
                           
                                <div className="single-team mb-40">
                                    <div className="team-thumb">
                                        <div className="brd">
                                            <Link to="#">
                                                <img src={teacher.Image} alt="img" />
                                            </Link>
                                        </div>
                                    </div>
                                    <div className="team-info">
                                        <h4>
                                            <Link to={teacher.namelink}>{teacher.Name}</Link>
                                        </h4>
                                       
                                        <div className="text-dark c-lineheight2">
                                            <p > <i className="fal fa-graduation-cap me-2" />{teacher.Position}</p>
                                            <p className="text-dark">{teacher.position2}</p>
                                            <p className="text-dark">Batch : {teacher.Batch}</p>
                                            <p className="text-dark">Areas of Research : {teacher.AreasofResearch}</p>
                                            
                                            {/* Parse the HTML content and extract text */}
                                            
                                            <p className="text-dark">Guide: <Link className="text-maroon" to={teacher.GuideLink} target="_blank"> {teacher.GuideName}</Link> </p>

                                            {(teacher.CoGuideName !== undefined && teacher.CoGuideName !== "") && (
                                                <p className="text-dark">Co-Guide: <a className="text-maroon" href={teacher.CoGuideLink} target="_blank" >{teacher.CoGuideName}</a></p>
                                            )}

                                            

                                            {/* <p className="text-orange"><i className="fal fa-envelope  me-2"></i> <Link to={teacher.Email} target="_blank" className="btn btn-primary">{teacher.Email}</Link></p> */}
                                            <p className="text-dark"><i className="fal fa-envelope  me-1"></i> Email : {teacher.Email}</p>
                                        </div>                                       
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </section>
        </>
    )
}

// // Function to parse HTML content and extract text
// function parseHTML(htmlString) {
//     const tempElement = document.createElement('div');
//     tempElement.innerHTML = htmlString;
//     return tempElement.textContent || tempElement.innerHTML || '';
// }


export default Main